<template>
    <div class="order-form-back">
        <div class="order-form">
            <div v-if="confirmDelete" class="confirmDelete">
                <h1>Удалить заказ?</h1>
                <div class="confirmDeleteBtn">
                    <button @click="this.$emit('removeOrder', this.editOrder.order_id)">Да</button>
                    <button @click="confirmDelete = false">Отмена</button>
                </div>
            </div>

            <div class="order-form-header">
                <h2 v-if="this.isOperator">Информация по заказу</h2>
                <h2 v-else>{{ isEditing && !isRegular ? "Редактировать заказ" : "Создать заказ" }}</h2>
                <svg @click="closeModal" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
                    fill="#000000">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                            sketch:type="MSPage">
                            <g id="Icon-Set-Filled" sketch:type="MSLayerGroup"
                                transform="translate(-469.000000, -1041.000000)" fill="#000000">
                                <path
                                    d="M487.148,1053.48 L492.813,1047.82 C494.376,1046.26 494.376,1043.72 492.813,1042.16 C491.248,1040.59 488.712,1040.59 487.148,1042.16 L481.484,1047.82 L475.82,1042.16 C474.257,1040.59 471.721,1040.59 470.156,1042.16 C468.593,1043.72 468.593,1046.26 470.156,1047.82 L475.82,1053.48 L470.156,1059.15 C468.593,1060.71 468.593,1063.25 470.156,1064.81 C471.721,1066.38 474.257,1066.38 475.82,1064.81 L481.484,1059.15 L487.148,1064.81 C488.712,1066.38 491.248,1066.38 492.813,1064.81 C494.376,1063.25 494.376,1060.71 492.813,1059.15 L487.148,1053.48"
                                    id="cross" sketch:type="MSShapeGroup"> </path>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>

            <div class="historyCalls" v-if="isEditing">
                <div class="historyCallsList">
                    <h3>История звонков</h3>
                    <div v-if="historyCalls.length" class="table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Дата звонка</th>
                                    <th>Оператор</th>
                                    <th>Статус</th>
                                    <th>Комментарий</th>
                                    <th>Позвонить</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="historyCallsListElem" v-for="elem in historyCalls" :key="elem.call_id"
                                    :style="`background-color: ${elem.operator_color};`">
                                    <td>{{ this.getFormatDate(elem.call_date) }}</td>
                                    <td>{{ elem.operator_name }}</td>
                                    <td>{{ getStatus(elem.status) }}</td>
                                    <td>{{ elem.result }}</td>
                                    <td>{{ elem.next_call ? this.getFormatDate(elem.next_call) : 'нет' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>Звонков по заказу нет</div>
                </div>
            </div>

            <div v-if="this.isAdmin" class="form-group" v-for="(value, key) in formFields" :key="key"
                :class="value.class ? value.class : ''">
                <label :for="key">{{ value.label }}</label>

                <PhoneInput v-if="key === 'phone'" v-model="editOrder[key]" />
                <textarea v-else-if="value.type === 'textarea'" v-model="editOrder[key]" :id="key"></textarea>
                <input v-else-if="value.type === 'checkbox'" :true-value="1" :false-value="0" type="checkbox"
                    v-model="editOrder[key]" :id="key" />
                <input v-else-if="value.type !== 'select'" v-model="editOrder[key]" :type="value.type" :id="key" />
                <select v-else v-model="editOrder[key]" :id="key">
                    <option value="0" v-if="key == 'operator_id'">Без оператора</option>
                    <option v-for="option in value.options" :key="option.value" :value="option.value">
                        {{ option.label }}
                    </option>
                </select>

                <div class="additional_phone" v-if="isEditing && key == 'phone' && editOrder.old_phone">
                    {{ editOrder.old_phone }}
                </div>

                <div class="search-plan" v-if="!isEditing && key == 'request_id'">
                    <div v-if="!oPlan">
                        Похожего заказа в планере по ID нет
                    </div>
                    <a v-else @click="updateOrderDataFromPlaner">
                        Найден похожий заказ в планере {{ oPlan.request_id }}, нажмите, чтобы вставить сюда данные из
                        планера
                    </a>
                </div>
            </div>

            <div class="form-group is_regular" v-if="this.isAdmin && (!isEditing || isRegular)">

                <div class="is_regular_checkbox">
                    <label>
                        <input :true-value="1" :false-value="0" type="checkbox" v-model="editOrder.is_regular" />
                        Постоянный клиент
                    </label>

                    <div class="help" v-if="!editOrder.is_regular">
                        Клиент появится во вкладке "Постоянники"<br>
                        Там можно будет быстро создавать заказы по одному и тому же адресу, не вводя все данные
                        заново<br>
                        Дата следующей уборки будет автоматически предлагаться на основе прошлого промежутка между
                        датами в днях
                    </div>

                </div>

                <div class="is_regular_setting" v-if="editOrder.is_regular">
                    <div class="form-group">
                        <label>Дата следующей уборки (появится в Постоянниках) <span class="required">*</span></label>
                        <input v-model="editOrder.next_order" type="date" />
                    </div>
                    <div class="form-group">
                        <label>Дата звонка для подтверждения (появится в Планере)</label>
                        <input v-model="editOrder.next_call" type="date" />
                    </div>
                </div>
            </div>

            <div class="form-group" v-if="this.isAdmin && editOrder.plan_id">
                <label :for="`removePlaner`">Удалить из планера после создания</label>
                <input :true-value="1" :false-value="0" type="checkbox" v-model="editOrder.remove_plan_id"
                    :id="`removePlaner`" />
            </div>

            <h2 class="headerElem" v-if="this.isAdmin">Выбор мастеров (выбрано {{ this.editOrder.workers.length }})</h2>
            <div v-if="this.isAdmin" class="workers-list">
                <div v-for="worker in sortedWorkers" :key="worker.user_id"
                    :class="{ 'selected-worker': isWorkerSelected(worker.user_id) }" @click="toggleWorker(worker)">
                    {{ worker.name }}
                    <input @click.stop v-if="isWorkerSelected(worker.user_id)"
                        v-model="editOrder.workers.find(w => w.user_id === worker.user_id).cleaner_salary" type="number"
                        placeholder="Зарплата" />
                </div>
            </div>

            <div class="error" v-if="error">{{ error }}</div>

            <button v-if="this.isAdmin" @click="sendOrder">
                {{ isEditing && !isRegular ? "Сохранить изменения" : "Создать заказ" }}
            </button>
            <button v-if="(isEditing && !isRegular) && this.isAdmin" @click="confirmDelete = true">Удалить
                заказ</button>

            <div v-if="this.isOperator" class="form-group" v-for="(value, key) in formFields" :key="key"
                :class="value.class ? value.class : ''">

                <label :for="key">{{ value.label }}</label>

                <div v-if="key == 'phone'">
                    <button v-if="phoneNumber == null" @click="getPhoneClient">Получить номер</button>
                    <a v-else="phoneNumber" :href="`tel:${phoneNumber}`">{{ phoneNumber }}</a>
                    <div v-if="oldPhoneNumber">Доп инфо: {{ oldPhoneNumber }}</div>
                </div>
                <div v-else-if="key == 'our_site'">{{ editOrder[key] ? 'Да' : 'Нет' }}</div>
                <div v-else-if="key == 'order_date'">{{ this.getFormatDate(editOrder[key]) }}</div>
                <div v-else>{{ editOrder[key] }}</div>
            </div>

            <div class="historyCalls" v-if="isEditing">

                <div class="historyCallsCreate">

                    <div class="form-group comment">
                        <label>Результат звонка</label>
                        <textarea v-model="oCall.result"></textarea>
                    </div>

                    <div class="form-group">
                        <label>Дата звонка</label>
                        <input v-model="oCall.call_date" type="date" />
                    </div>

                    <div class="form-group">
                        <label>Дата следующего звонка</label>
                        <input v-model="oCall.next_call" type="date" />
                    </div>
                    <select v-model="oCall.status">
                        <option :value="el - 1" v-for="el in 8">{{ getStatus(el - 1) }}</option>
                    </select>

                    <div class="error" v-if="errorAddHistory">
                        {{ errorAddHistory }}
                    </div>

                    <button @click="addHistory()">Добавить звонок</button>

                </div>
            </div>
        </div>




    </div>
</template>

<script>
export default {
    name: "ModalOrder",
    props: {
        orderData: Object,
    },
    data() {
        return {
            orderTypes: ['Клининг', 'Химчистка', 'Окна'],
            workers: [],
            operators: [],

            historyCalls: [],
            oCall: {
                status: 0,
                result: null,
                next_call: null,
                call_date: new Date().toISOString().split("T")[0],
            },

            oPlan: null,

            errorAddHistory: null,

            error: null,

            confirmDelete: false,

            phoneNumber: null,
            oldPhoneNumber: null,

            timerSearchOrder: null,

            editOrder: {
                order_id: null,
                request_id: "",
                order_date: "",
                customer: "",
                address: "",
                phone: "",
                price: "",
                percentage_broker: "",
                comment: "",
                our_site: 0,
                type: "",
                operator_id: 0,
                is_regular: 0,
                workers: []
            },
        };
    },
    computed: {
        sortedWorkers() {
            return this.workers.slice().sort((a, b) => {
                const aSelected = this.isWorkerSelected(a.user_id);
                const bSelected = this.isWorkerSelected(b.user_id);

                if (aSelected !== bSelected) {
                    return aSelected ? -1 : 1;
                }

                const nameA = a.name || '';
                const nameB = b.name || '';
                return nameA.localeCompare(nameB);
            });
        },
        formFields() {
            return this.isAdmin ? {
                request_id: { label: "ID заказа", type: "text", class: "requestID" },
                order_date: { label: "Дата заказа", type: "date" },
                customer: { label: "Заказчик", type: "text" },
                address: { label: "Адрес", type: "text" },
                phone: { label: "Телефон", type: "text" },
                price: { label: "Цена", type: "number" },
                percentage_broker: { label: "Сумма посреднику", type: "number" },
                comment: { label: "Комментарий", type: "textarea", class: "comment" },
                our_site: { label: "Наш сайт", type: "checkbox" },
                type: { label: "Тип заказа", type: "select", options: [] },
                operator_id: { label: "Оператор", type: "select", options: [] },
            } : {
                request_id: { label: "ID заказа", type: "text", class: "requestID" },
                order_date: { label: "Дата заказа", type: "date" },
                customer: { label: "Заказчик", type: "text" },
                address: { label: "Адрес", type: "text" },
                phone: { label: "Телефон", type: "text" },
                price: { label: "Цена", type: "number" },
                comment: { label: "Комментарий", type: "textarea", class: "comment" },
                our_site: { label: "Наш сайт", type: "checkbox" },
                type: { label: "Тип заказа", type: "select", options: [] },
            };
        },

        isEditing() {
            if (this.editOrder.next_order) return true;
            return !!this.editOrder.order_id;
        },
        isRegular() {
            return !!this.editOrder.next_order;
        }
    },
    methods: {
        validateData() {
            if (!this.editOrder.order_date) {
                this.error = 'Выберите дату заказа'
                return false;
            }
            if (!this.editOrder.customer) {
                this.error = 'Напишите заказчика'
                return false;
            }
            if (!this.editOrder.address) {
                this.error = 'Напишите адрес'
                return false;
            }
            if (!this.editOrder.type) {
                this.error = 'Выберите тип'
                return false;
            }

            if (this.editOrder.is_regular && !this.editOrder.next_order) {
                this.error = 'Укажите дату следующей уборки';
                return false;
            }

            return true;
        },
        updateOrderDataFromPlaner() {
            this.editOrder.customer = this.oPlan.customer;
            this.editOrder.comment = this.oPlan.comment;
            this.editOrder.address = this.oPlan.address;
            this.editOrder.plan_id = this.oPlan.plan_id;
            if (this.oPlan.user_id) this.editOrder.operator_id = this.oPlan.user_id;
            this.editOrder.remove_plan_id = 1;

            this.oPlan = null;
        },
        getStatus(index) {
            if (index == 0) return `Без статуса`;
            if (index == 1) return `Клиент думает`;
            if (index == 2) return `Недозвон`;
            if (index == 3) return `Созвониться`;
            if (index == 4) return `Просмотр`;
            if (index == 5) return `В работе`;
            if (index == 6) return `Отказ`;
            if (index == 7) return `Закрыт`;
        },
        async getPhoneClient() {
            const result = await this.requestData({
                action: "getPhoneClient",
                order_id: this.editOrder.order_id,
            });

            this.phoneNumber = result[0].phone;
            this.oldPhoneNumber = !result[0].old_phone || result[0].old_phone == result[0].phone ? null : result[0].old_phone;

            this.setLoading(false);
        },
        async addHistory() {
            this.errorAddHistory = null;
            if (!this.oCall.status) {
                this.errorAddHistory = "Укажите статус звонка";
                return;
            }
            if (!this.oCall.call_date) {
                this.errorAddHistory = "Укажите дату звонка";
                return;
            }
            if (!this.oCall.result) {
                this.errorAddHistory = "Напишите результат звонка";
                return;
            }

            const result = await this.requestData({
                action: "addHistory",
                oCall: this.oCall,
                order_id: this.editOrder.order_id,
            });
            if (result) {

                this.closeModal();
            } else {

            }
            this.setLoading(false);
        },
        async getPlanByRequestId() {
            const result = await this.requestData({
                action: "getPlanByRequestId",
                request_id: this.editOrder.request_id,
            });
            this.oPlan = result;
            this.setLoading(false);
        },
        async getHistoryCalls() {
            const result = await this.requestData({
                action: "getHistoryCalls",
                order_id: this.editOrder.order_id,
            });
            this.historyCalls = result;
            this.setLoading(false);
        },
        callClient(phone) {
            window.location.href = `tel:${phone}`;
        },
        sendOrder() {
            if (this.validateData())
                this.$emit('sendOrder', this.editOrder);
        },
        closeModal() {
            this.$emit('closeModal');
        },
        isWorkerSelected(userId) {
            return this.editOrder.workers.some(w => w.user_id === userId);
        },
        toggleWorker(worker) {
            const index = this.editOrder.workers.findIndex(w => w.user_id === worker.user_id);
            if (index === -1) {
                this.editOrder.workers.push({ user_id: worker.user_id, cleaner_salary: "" });
            } else {
                this.editOrder.workers.splice(index, 1);
            }
        },
        getWorkerSalary(userId) {
            const worker = this.editOrder.workers.find(w => w.user_id === userId);
            return worker ? worker.cleaner_salary : "";
        },
        updateWorkerSalary(userId, salary) {
            const worker = this.editOrder.workers.find(w => w.user_id === userId);
            if (worker) worker.cleaner_salary = salary;
        },
        async getWorkers() {
            const isEditing = this.orderData && this.orderData.order_id ? true : false;
            console.log(isEditing, this.orderData)
            const result = await this.requestData({
                action: "getWorkers",
                hidden: isEditing ? null : 0,
            });
            this.workers = result.filter(el => el.root == 0);
            this.operators = result.filter(el => el.root == 2);
            this.setLoading(false);
        },
        getDateDifferenceAndAdd(date1, date2) {
            // Преобразуем строки в объекты Date
            const d1 = new Date(date1);
            const d2 = new Date(date2);

            // Получаем разницу в миллисекундах
            const diffTime = Math.abs(d2 - d1);

            // Конвертируем разницу в днях
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            // Прибавляем разницу к дате 2
            const newDate = new Date(d2);
            newDate.setDate(d2.getDate() + diffDays);

            // Преобразуем новую дату обратно в строку формата 'YYYY-MM-DD'
            return newDate.toISOString().split('T')[0];
        },
        getPreviousDay(date) {
            // Преобразуем строку в объект Date
            const d = new Date(date);

            // Уменьшаем день на 1
            d.setDate(d.getDate() - 1);

            // Преобразуем дату обратно в строку формата 'YYYY-MM-DD'
            const previousDate = d.toISOString().split('T')[0];

            return previousDate;
        },
    },
    watch: {
        orderTypes: {
            handler(newVal) {
                if (this.formFields.type) {
                    this.formFields.type.options = newVal.map(t => ({ value: t, label: t }));
                }
            },
            immediate: true
        },
        operators: {
            handler(newVal) {
                if (this.formFields.operator_id) {
                    this.formFields.operator_id.options = newVal.map(o => ({ value: o.user_id, label: o.name }));
                }
            },
            immediate: true
        },
        'editOrder.request_id'(newVal) {
            clearInterval(this.timerSearchOrder);
            if (!this.isEditing && newVal) {
                this.timerSearchOrder = setTimeout(() => {
                    this.oPlan = null;
                    this.getPlanByRequestId();
                }, "1000");
            }
        },
    },
    mounted() {
        this.getWorkers();

        if (this.orderData) {
            this.editOrder = { ...this.orderData };

            if (this.editOrder.next_order && this.isAdmin) {
                const next_order = this.getDateDifferenceAndAdd(this.editOrder.order_date, this.editOrder.next_order);
                this.editOrder.order_id = null;
                this.editOrder.order_date = this.editOrder.next_order;
                this.editOrder.is_regular = 1;
                this.editOrder.next_order = next_order;
                this.editOrder.next_call = this.getPreviousDay(next_order);
            }

            this.getHistoryCalls();
        }
    }
};
</script>
<style scoped>
.order-form {
    max-width: 700px;
    width: 90%;
    max-height: 90%;
    border: 1px solid #ddd;
    border-radius: 10px;
    background: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 5px;
    padding: 10px;
    overflow: auto;
    position: relative;
}

label {
    display: block;
    font-weight: bold;
}

input,
select {
    width: 100%;
    padding: 5px;
    margin-top: 5px;
}

.workers-list {
    display: flex;
    gap: 5px;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
    overflow: auto;
    max-height: 220px;
}

.workers-list div {
    padding: 5px 10px;
    border: 1px solid #ddd;
    cursor: pointer;
    width: 100%;
    opacity: .4;
}

div.selected-worker {
    background-color: #0072ff;
    color: white;
    opacity: 1;
}

.order-form-back {
    position: fixed;
    background: #000000a6;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999999999;
    top: 0;
    left: 0;
}

.form-group {
    min-width: 49%;
    max-width: 100%;
}

.form-group.comment {
    width: 100%;
}

.form-group textarea {
    width: 100%;
    resize: vertical;
    padding: 10px;
}

.order-form-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.order-form-header svg {
    width: 20px;
    cursor: pointer;
    transition: all .3s;
}

.order-form-header svg:hover {
    opacity: .5;
}

.requestID {
    width: 100%;
}

.historyCalls {
    width: 100%;
    margin-bottom: 30px;
}

.historyCallsCreate {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
    margin-top: 30px;
}

.historyCallsList thead {
    font-size: 13px;
}

.historyCallsList table {
    width: 100%;
}

.historyCallsList th,
.historyCallsList td {
    border: 1px solid black;
    padding: 5px;
}

.historyCallsList h3 {
    margin: 10px 0;
    text-align: center;
    width: 100%;
}

.headerElem {
    width: 100%;
    text-align: center;
    margin: 20px 0;
}

.search-plan a {
    color: blue;
    font-weight: bold;
    text-decoration: underline;
    transition: all .3s;
    cursor: pointer;
}

.search-plan a:hover {
    opacity: .5;
}

button {
    width: 100%;
    margin-top: 15px;
}

.additional_phone {
    font-size: 11px;
    margin: 10px 0;
}

.is_regular {
    width: 100%;
    border-radius: 5px;
    padding: 5px;
    box-shadow: 0px 0px 10px -5px black;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
}

.is_regular_checkbox label {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}

.is_regular_checkbox {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
}

.is_regular_checkbox input[type="checkbox"] {
    width: 30px;
    margin: 0;
}
</style>